(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('rmsListFilterStatusSelection', rmsListFilterStatusSelection);

    function rmsListFilterStatusSelection() {
        return {
            restrict: 'E',
            scope: {
                options: '='
            },
            controller: rmsListFilterStatusSelectionCtrl,
            controllerAs: 'vm',
            bindToController: true
        };
    }

    function rmsListFilterStatusSelectionCtrl(lodash, rmsListFilterStatusSelectionFactory, $scope, GenericModel, $q, $compile, $element, $templateCache, $timeout, ListFilterStateFactory) {
        var vm = this;
        this.$onInit = function() {
            $scope.listFilterIdentifier = lodash.get(vm.options, 'identifier', 'default');
            rmsListFilterStatusSelectionFactory.sync(vm);
            $scope.$on('$destroy', function () {
                rmsListFilterStatusSelectionFactory.destroy();
            });
            syncFilters();

            let templateUrl = 'common/app/components/list-filter-status-selection/list-filter-status-selection';
            if (lodash.has(vm.options, 'templateUrl')) {
                templateUrl = vm.options.templateUrl;
            }
            const template = $templateCache.get(templateUrl);
            $element.html(template);
            $compile($element.contents())($scope);

            vm.selectStatus = selectStatus;
            vm.refreshData = setData;
            vm.isActive = isActive;
        }

        function syncFilters() {
            $timeout(function () {
                //ListFilterService.getFilterService().syncActiveFilter(vm);
                $scope.listFilterService = ListFilterStateFactory.get($scope.listFilterIdentifier);
                vm.listFilterData = {};
                $scope.listFilterService.sync(vm.listFilterData);
                vm.activeFilters = $scope.listFilterService.getFilterService().getActiveFilters();
                $scope.listFilterService.updateToolbarButtons(status);

                $scope.$watch(function () {
                    return $scope.listFilterService.getFilterService().getActiveFilters();
                }, function () {
                    vm.activeFilters = $scope.listFilterService.getFilterService().getActiveFilters();
                    $scope.listFilterService.updateToolbarButtons(status);
                });
            });
        }

        function isActive(status) {
            var pipelineValue = lodash.get(vm.activeFilters, 'pipeline[0].value', 0);
            pipelineValue = pipelineValue.map(function (_pipelineValue) {
                return _pipelineValue.toString();
            });

            //check if any of the status values is equal to pipeline valuesg
            return pipelineValue.some(function (_value) {
                return status.value.findIndex(function (_statusValue) {
                    return _value === _statusValue.toString();
                }) !== -1;
            });
        }

        function selectStatus(status) {

            var detailPanelAlwaysOn = lodash.get(vm.options, 'detail_panel.always_on', false);

            var canMassSelect = lodash.get(status, 'can_mass_select', false);

            var resetToOne = false;
            if ((vm.selectedStatus !== status.value)) {
                if (!detailPanelAlwaysOn) {
                    $scope.listFilterService.closeDetailPanel();
                }
                // $scope.listFilterService.setPage(1);
                $scope.listFilterService.clearSelected();
                resetToOne = true;
            }

            let template = lodash.get(status, 'filter_template_override', null);
            if (template === null) {
                template = vm.options.status_selection.filter_template;
            }
            // template = lodash.isNull(template) ? vm.options.status_selection.filter_template : template;
            $timeout(function () {
                if (!lodash.isEmpty(template)) {
                    $scope.listFilterService.getFilterService().setActiveFilter('pipeline', [angular.merge({}, template, {value: status.value})]);
                    $scope.listFilterService.refreshGrid(resetToOne);
                    $scope.listFilterService.toggleSelectable(canMassSelect);
                }
                if (lodash.isEmpty(template)) {
                    $scope.listFilterService.getFilterService().setActiveFilter('pipeline', [{value: status.value}]);
                    $scope.listFilterService.refreshGrid(resetToOne);
                    $scope.listFilterService.toggleSelectable(canMassSelect);
                }
            });

        }

        function setData() {
            $timeout(function () {
                $q.when(fetchData()).then(function (res) {
                    vm.data = res;
                    $scope.listFilterService.setPipelineData(res);
                });
            });
        }

        function fetchData() {
            if (lodash.has(vm.options.status_selection, 'datasource.url') && !lodash.has(vm.options.status_selection, 'datasource.data')) {
                const path = vm.options.status_selection.datasource.url;
                const method = lodash.get(vm.options.status_selection, 'datasource.method', 'get');
                var model = new GenericModel(path);
                const params = $scope.listFilterService.generateResourceOption({}, {
                    data: {filter: $scope.listFilterService.getFilterService().getAppliedFilters()}
                }, method);

                return model[method]({}, params).$promise.then(function (res) {
                    return res.data;
                });
            }
            if (!lodash.has(vm.options.status_selection, 'datasource.url') && lodash.has(vm.options.status_selection, 'datasource.data')) {
                return vm.options.status_selection.datasource.data;
            }
        }
    }
})();